export type BackendMessageCategory = "error" | "success";

export type BackendMessageDefinition = {
  translationKey: string;
  category: BackendMessageCategory;
  hasParams: boolean;
};

export const BACKEND_MESSAGE_MAP = {
  ERROR_ACCOUNT_LOCKED: {
    translationKey: "common.backendMessages.errors.accountLocked",
    category: "error",
    hasParams: true,
  },
  ERROR_ACCOUNT_LOCKED_ATTEMPTS_REMAINING: {
    translationKey:
      "common.backendMessages.errors.accountLockedAttemptsRemaining",
    category: "error",
    hasParams: true,
  },
  ERROR_ACCOUNT_LOCKED_ONE_MORE_ATTEMPT: {
    translationKey: "common.backendMessages.errors.accountLockedOneMoreAttempt",
    category: "error",
    hasParams: false,
  },
  ERROR_ANSWER_NOT_FOUND: {
    translationKey: "common.backendMessages.errors.answerNotFound",
    category: "error",
    hasParams: true,
  },
  ERROR_ANSWER_QUESTION_KEY_INVALID: {
    translationKey: "common.backendMessages.errors.answerQuestionKeyInvalid",
    category: "error",
    hasParams: false,
  },
  ERROR_APPLE_IAP_INVALID_JSON: {
    translationKey: "common.backendMessages.errors.appleIapInvalidJson",
    category: "error",
    hasParams: false,
  },
  ERROR_APPLE_IAP_MISSING_SIGNED_PAYLOAD: {
    translationKey:
      "common.backendMessages.errors.appleIapMissingSignedPayload",
    category: "error",
    hasParams: false,
  },
  ERROR_APPLE_IAP_WEBHOOK_PROCESSING_FAILED: {
    translationKey:
      "common.backendMessages.errors.appleIapWebhookProcessingFailed",
    category: "error",
    hasParams: false,
  },
  ERROR_CHAT_ARCHIVAL_TASK_FAILED: {
    translationKey: "common.backendMessages.errors.chatArchivalTaskFailed",
    category: "error",
    hasParams: true,
  },
  ERROR_CHAT_CELERY_TEST_FAILED: {
    translationKey: "common.backendMessages.errors.chatCeleryTestFailed",
    category: "error",
    hasParams: true,
  },
  ERROR_CHAT_QUERY_TOO_LONG: {
    translationKey: "common.backendMessages.errors.chatQueryTooLong",
    category: "error",
    hasParams: false,
  },
  ERROR_CHAT_RULES_REFRESH_FAILED: {
    translationKey: "common.backendMessages.errors.chatRulesRefreshFailed",
    category: "error",
    hasParams: true,
  },
  ERROR_CHAT_SESSION_ALREADY_CLOSED: {
    translationKey: "common.backendMessages.errors.chatSessionAlreadyClosed",
    category: "error",
    hasParams: true,
  },
  ERROR_CHAT_SESSION_CLOSE_ALL_FAILED: {
    translationKey: "common.backendMessages.errors.chatSessionCloseAllFailed",
    category: "error",
    hasParams: true,
  },
  ERROR_CHAT_SESSION_CLOSE_FAILED: {
    translationKey: "common.backendMessages.errors.chatSessionCloseFailed",
    category: "error",
    hasParams: true,
  },
  ERROR_CHAT_SESSION_GET_ACTIVE_FAILED: {
    translationKey: "common.backendMessages.errors.chatSessionGetActiveFailed",
    category: "error",
    hasParams: true,
  },
  ERROR_CHAT_SESSION_NOT_FOUND: {
    translationKey: "common.backendMessages.errors.chatSessionNotFound",
    category: "error",
    hasParams: false,
  },
  ERROR_CHAT_STREAM_ERROR: {
    translationKey: "common.backendMessages.errors.chatStreamError",
    category: "error",
    hasParams: false,
  },
  ERROR_DECRYPTION_FAILED: {
    translationKey: "common.backendMessages.errors.decryptionFailed",
    category: "error",
    hasParams: false,
  },
  ERROR_ENCRYPTION_SERVICE_NOT_CONFIGURED: {
    translationKey:
      "common.backendMessages.errors.encryptionServiceNotConfigured",
    category: "error",
    hasParams: false,
  },
  ERROR_FILE_DOCX_EXCEEDS_SIZE_LIMIT: {
    translationKey: "common.backendMessages.errors.fileDocxExceedsSizeLimit",
    category: "error",
    hasParams: false,
  },
  ERROR_FILE_IMAGE_EXCEEDS_SIZE_LIMIT: {
    translationKey: "common.backendMessages.errors.fileImageExceedsSizeLimit",
    category: "error",
    hasParams: false,
  },
  ERROR_FILE_IMAGE_TYPE_NOT_ALLOWED: {
    translationKey: "common.backendMessages.errors.fileImageTypeNotAllowed",
    category: "error",
    hasParams: true,
  },
  ERROR_FILE_INSUFFICIENT_PERMISSIONS: {
    translationKey: "common.backendMessages.errors.fileInsufficientPermissions",
    category: "error",
    hasParams: false,
  },
  ERROR_FILE_NOT_FOUND: {
    translationKey: "common.backendMessages.errors.fileNotFound",
    category: "error",
    hasParams: false,
  },
  ERROR_FILE_PDF_EXCEEDS_SIZE_LIMIT: {
    translationKey: "common.backendMessages.errors.filePdfExceedsSizeLimit",
    category: "error",
    hasParams: false,
  },
  ERROR_FILE_READ_FAILED: {
    translationKey: "common.backendMessages.errors.fileReadFailed",
    category: "error",
    hasParams: true,
  },
  ERROR_FILE_SIZE_EXCEEDS_LIMIT: {
    translationKey: "common.backendMessages.errors.fileSizeExceedsLimit",
    category: "error",
    hasParams: true,
  },
  ERROR_FILE_TOO_MANY_FILES: {
    translationKey: "common.backendMessages.errors.fileTooManyFiles",
    category: "error",
    hasParams: true,
  },
  ERROR_FILE_TOO_MANY_FILES_ATTACHED: {
    translationKey: "common.backendMessages.errors.fileTooManyFilesAttached",
    category: "error",
    hasParams: true,
  },
  ERROR_FILE_TYPE_NOT_ALLOWED: {
    translationKey: "common.backendMessages.errors.fileTypeNotAllowed",
    category: "error",
    hasParams: true,
  },
  ERROR_FILE_UPLOAD_AZURE_FAILED: {
    translationKey: "common.backendMessages.errors.fileUploadAzureFailed",
    category: "error",
    hasParams: false,
  },
  ERROR_FILE_UPLOAD_FAILED: {
    translationKey: "common.backendMessages.errors.fileUploadFailed",
    category: "error",
    hasParams: true,
  },
  ERROR_GOOGLE_PLAY_INVALID_BASE64_JSON: {
    translationKey: "common.backendMessages.errors.googlePlayInvalidBase64Json",
    category: "error",
    hasParams: true,
  },
  ERROR_GOOGLE_PLAY_INVALID_ENVELOPE: {
    translationKey: "common.backendMessages.errors.googlePlayInvalidEnvelope",
    category: "error",
    hasParams: true,
  },
  ERROR_GOOGLE_PLAY_MISSING_MESSAGE_ID_OR_DATA: {
    translationKey:
      "common.backendMessages.errors.googlePlayMissingMessageIdOrData",
    category: "error",
    hasParams: false,
  },
  ERROR_GOOGLE_PLAY_MISSING_REQUIRED_FIELDS: {
    translationKey:
      "common.backendMessages.errors.googlePlayMissingRequiredFields",
    category: "error",
    hasParams: false,
  },
  ERROR_GOOGLE_PLAY_PACKAGE_NAME_REQUIRED: {
    translationKey:
      "common.backendMessages.errors.googlePlayPackageNameRequired",
    category: "error",
    hasParams: false,
  },
  ERROR_GOOGLE_PLAY_PACKAGE_NOT_ALLOWED: {
    translationKey: "common.backendMessages.errors.googlePlayPackageNotAllowed",
    category: "error",
    hasParams: true,
  },
  ERROR_GOOGLE_PLAY_PROCESSING_FAILED: {
    translationKey: "common.backendMessages.errors.googlePlayProcessingFailed",
    category: "error",
    hasParams: true,
  },
  ERROR_GOOGLE_PLAY_PRODUCT_ID_REQUIRED: {
    translationKey: "common.backendMessages.errors.googlePlayProductIdRequired",
    category: "error",
    hasParams: false,
  },
  ERROR_GOOGLE_PLAY_PURCHASE_DETAILS_REQUIRED: {
    translationKey:
      "common.backendMessages.errors.googlePlayPurchaseDetailsRequired",
    category: "error",
    hasParams: false,
  },
  ERROR_GOOGLE_PLAY_PURCHASE_TOKEN_REQUIRED: {
    translationKey:
      "common.backendMessages.errors.googlePlayPurchaseTokenRequired",
    category: "error",
    hasParams: false,
  },
  ERROR_GOOGLE_PLAY_PURCHASE_VERIFICATION_FAILED: {
    translationKey:
      "common.backendMessages.errors.googlePlayPurchaseVerificationFailed",
    category: "error",
    hasParams: true,
  },
  ERROR_GOOGLE_PLAY_PURCHASE_VERIFICATION_FAILED_UNEXPECTED: {
    translationKey:
      "common.backendMessages.errors.googlePlayPurchaseVerificationFailedUnexpected",
    category: "error",
    hasParams: false,
  },
  ERROR_GOOGLE_PLAY_SERVICE_CONFIGURATION_ERROR: {
    translationKey:
      "common.backendMessages.errors.googlePlayServiceConfigurationError",
    category: "error",
    hasParams: true,
  },
  ERROR_INCORRECT_EMAIL_OR_PASSWORD: {
    translationKey: "common.backendMessages.errors.incorrectEmailOrPassword",
    category: "error",
    hasParams: false,
  },
  ERROR_INCORRECT_PASSWORD: {
    translationKey: "common.backendMessages.errors.incorrectPassword",
    category: "error",
    hasParams: false,
  },
  ERROR_INTERNAL_SERVER_ERROR: {
    translationKey: "common.backendMessages.errors.internalServerError",
    category: "error",
    hasParams: false,
  },
  ERROR_EXPIRED_PROVIDER_TOKEN: {
    translationKey: "common.backendMessages.errors.expiredProviderToken",
    category: "error",
    hasParams: false,
  },
  ERROR_INVALID_PROVIDER_TOKEN: {
    translationKey: "common.backendMessages.errors.invalidProviderToken",
    category: "error",
    hasParams: false,
  },
  ERROR_INVALID_REFRESH_TOKEN: {
    translationKey: "common.backendMessages.errors.invalidRefreshToken",
    category: "error",
    hasParams: false,
  },
  ERROR_INVALID_TOKEN: {
    translationKey: "common.backendMessages.errors.invalidToken",
    category: "error",
    hasParams: false,
  },
  ERROR_INVALID_TOKEN_TYPE: {
    translationKey: "common.backendMessages.errors.invalidTokenType",
    category: "error",
    hasParams: false,
  },
  ERROR_NOT_AUTHENTICATED: {
    translationKey: "common.backendMessages.errors.notAuthenticated",
    category: "error",
    hasParams: false,
  },
  ERROR_COULD_NOT_VALIDATE_CREDENTIALS: {
    translationKey: "common.backendMessages.errors.couldNotValidateCredentials",
    category: "error",
    hasParams: false,
  },
  ERROR_ACCOUNT_INACTIVE: {
    translationKey: "common.backendMessages.errors.accountInactive",
    category: "error",
    hasParams: false,
  },
  ERROR_PROVIDER_AUTH_FAILED: {
    translationKey: "common.backendMessages.errors.providerAuthFailed",
    category: "error",
    hasParams: false,
  },
  ERROR_UNSUPPORTED_PROVIDER: {
    translationKey: "common.backendMessages.errors.unsupportedProvider",
    category: "error",
    hasParams: false,
  },
  ERROR_LINKING_REQUIRED: {
    translationKey: "common.backendMessages.errors.linkingRequired",
    category: "error",
    hasParams: false,
  },
  ERROR_ACCOUNT_LINKING_FAILED: {
    translationKey: "common.backendMessages.errors.accountLinkingFailed",
    category: "error",
    hasParams: false,
  },
  ERROR_PROVIDER_UNAVAILABLE: {
    translationKey: "common.backendMessages.errors.providerUnavailable",
    category: "error",
    hasParams: false,
  },
  ERROR_ONBOARDING_INCOMPLETE: {
    translationKey: "common.backendMessages.errors.onboardingIncomplete",
    category: "error",
    hasParams: false,
  },
  ERROR_ACCOUNT_COMPLETION_NOT_REQUIRED: {
    translationKey: "common.backendMessages.errors.accountCompletionNotRequired",
    category: "error",
    hasParams: false,
  },
  ERROR_TOKEN_EXPIRED: {
    translationKey: "common.backendMessages.errors.tokenExpired",
    category: "error",
    hasParams: false,
  },
  ERROR_TOKEN_REVOKED: {
    translationKey: "common.backendMessages.errors.tokenRevoked",
    category: "error",
    hasParams: false,
  },
  ERROR_TOKEN_LIMIT_EXCEEDED: {
    translationKey: "common.backendMessages.errors.tokenLimitExceeded",
    category: "error",
    hasParams: false,
  },
  ERROR_DEBUG_TOKEN_CHECK_FAILED: {
    translationKey: "common.backendMessages.errors.debugTokenCheckFailed",
    category: "error",
    hasParams: true,
  },
  ERROR_PASSWORD_RESET_EMAIL_FAILED: {
    translationKey: "common.backendMessages.errors.passwordResetEmailFailed",
    category: "error",
    hasParams: false,
  },
  ERROR_PASSWORD_SAME_AS_CURRENT: {
    translationKey: "common.backendMessages.errors.passwordSameAsCurrent",
    category: "error",
    hasParams: false,
  },
  ERROR_PASSWORDS_DONT_MATCH: {
    translationKey: "common.backendMessages.errors.passwordsDontMatch",
    category: "error",
    hasParams: false,
  },
  ERROR_QUESTIONNAIRE_NOT_FOUND: {
    translationKey: "common.backendMessages.errors.questionnaireNotFound",
    category: "error",
    hasParams: false,
  },
  ERROR_RATE_LIMIT_EXCEEDED: {
    translationKey: "common.backendMessages.errors.rateLimitExceeded",
    category: "error",
    hasParams: true,
  },
  ERROR_ASSISTANT_PROMPT_NOT_FOUND: {
    translationKey: "common.backendMessages.errors.assistantPromptNotFound",
    category: "error",
    hasParams: false,
  },
  ERROR_ASSISTANT_PROMPT_NOT_AUTHORIZED: {
    translationKey:
      "common.backendMessages.errors.assistantPromptNotAuthorized",
    category: "error",
    hasParams: false,
  },
  ERROR_ASSISTANT_PROMPT_NOT_AUTHORIZED_TO_ACTIVATE: {
    translationKey:
      "common.backendMessages.errors.assistantPromptNotAuthorizedToActivate",
    category: "error",
    hasParams: false,
  },
  ERROR_ASSISTANT_PROMPT_NOT_AUTHORIZED_TO_DELETE: {
    translationKey:
      "common.backendMessages.errors.assistantPromptNotAuthorizedToDelete",
    category: "error",
    hasParams: false,
  },
  ERROR_ASSISTANT_PROMPT_NOT_AUTHORIZED_TO_UPDATE: {
    translationKey:
      "common.backendMessages.errors.assistantPromptNotAuthorizedToUpdate",
    category: "error",
    hasParams: false,
  },
  ERROR_VALIDATION_DATE_INVALID: {
    translationKey: "common.backendMessages.errors.validationDateInvalid",
    category: "error",
    hasParams: false,
  },
  ERROR_VALIDATION_EMAIL_INVALID: {
    translationKey: "common.backendMessages.errors.validationEmailInvalid",
    category: "error",
    hasParams: false,
  },
  ERROR_VALIDATION_FIELD_REQUIRED: {
    translationKey: "common.backendMessages.errors.validationFieldRequired",
    category: "error",
    hasParams: false,
  },
  ERROR_VALIDATION_GENERIC: {
    translationKey: "common.backendMessages.errors.validationGeneric",
    category: "error",
    hasParams: false,
  },
  ERROR_VALIDATION_INVALID_VALUE: {
    translationKey: "common.backendMessages.errors.validationInvalidValue",
    category: "error",
    hasParams: false,
  },
  ERROR_VALIDATION_PASSWORD_LENGTH: {
    translationKey: "common.backendMessages.errors.validationPasswordLength",
    category: "error",
    hasParams: false,
  },
  ERROR_VALIDATION_STRING_TOO_LONG: {
    translationKey: "common.backendMessages.errors.validationStringTooLong",
    category: "error",
    hasParams: true,
  },
  ERROR_VALIDATION_STRING_TOO_SHORT: {
    translationKey: "common.backendMessages.errors.validationStringTooShort",
    category: "error",
    hasParams: false,
  },
  ERROR_VALIDATION_TYPE_ERROR: {
    translationKey: "common.backendMessages.errors.validationTypeError",
    category: "error",
    hasParams: false,
  },
  ERROR_VALIDATION_VALUE_OUT_OF_RANGE: {
    translationKey: "common.backendMessages.errors.validationValueOutOfRange",
    category: "error",
    hasParams: false,
  },
  ERROR_RATE_LIMIT_RETRY_AFTER: {
    translationKey: "common.backendMessages.errors.rateLimitRetryAfter",
    category: "error",
    hasParams: true,
  },
  ERROR_SUBSCRIPTION_ADMIN_PRIVILEGES_REQUIRED: {
    translationKey:
      "common.backendMessages.errors.subscriptionAdminPrivilegesRequired",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_ALREADY_ACTIVE: {
    translationKey: "common.backendMessages.errors.subscriptionAlreadyActive",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_CANCELLED: {
    translationKey: "common.backendMessages.errors.subscriptionCancelled",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_CANCEL_FAILED: {
    translationKey: "common.backendMessages.errors.subscriptionCancelFailed",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_CANNOT_DOWNGRADE: {
    translationKey: "common.backendMessages.errors.subscriptionCannotDowngrade",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_CANNOT_SWITCH_TO_SAME_PLAN: {
    translationKey:
      "common.backendMessages.errors.subscriptionCannotSwitchToSamePlan",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_DAYS_ADVANCE_LIMIT: {
    translationKey:
      "common.backendMessages.errors.subscriptionDaysAdvanceLimit",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_DAY_CONSUMPTION_FREEMIUM_ONLY: {
    translationKey:
      "common.backendMessages.errors.subscriptionDayConsumptionFreemiumOnly",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_DAYS_MUST_BE_POSITIVE: {
    translationKey:
      "common.backendMessages.errors.subscriptionDaysMustBePositive",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_FREEMIUM_ACTIVATION_FAILED: {
    translationKey:
      "common.backendMessages.errors.subscriptionFreemiumActivationFailed",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_FREEMIUM_EXPIRED: {
    translationKey: "common.backendMessages.errors.subscriptionFreemiumExpired",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_FREEMIUM_TRIAL_ENDED: {
    translationKey:
      "common.backendMessages.errors.subscriptionFreemiumTrialEnded",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_FREEMIUM_TOKENS_EXHAUSTED: {
    translationKey:
      "common.backendMessages.errors.subscriptionFreemiumTokensExhausted",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_EXPIRED: {
    translationKey: "common.backendMessages.errors.subscriptionExpired",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_INVALID_PLAN_CHOICE: {
    translationKey:
      "common.backendMessages.errors.subscriptionInvalidPlanChoice",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_INVALID_STATUS: {
    translationKey: "common.backendMessages.errors.subscriptionInvalidStatus",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_NO_ACTIVE_SUBSCRIPTION: {
    translationKey:
      "common.backendMessages.errors.subscriptionNoActiveSubscription",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_NOT_ENOUGH_TOKENS_REMAINING: {
    translationKey:
      "common.backendMessages.errors.subscriptionNotEnoughTokensRemaining",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_PAYMENT_CONFIGURATION_ERROR: {
    translationKey:
      "common.backendMessages.errors.subscriptionPaymentConfigurationError",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_PAYMENT_PROCESSING_ERROR: {
    translationKey:
      "common.backendMessages.errors.subscriptionPaymentProcessingError",
    category: "error",
    hasParams: true,
  },
  ERROR_SUBSCRIPTION_PERIOD_ENDED: {
    translationKey: "common.backendMessages.errors.subscriptionPeriodEnded",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_STRIPE_CONFIGURATION_ERROR: {
    translationKey:
      "common.backendMessages.errors.subscriptionStripeConfigurationError",
    category: "error",
    hasParams: true,
  },
  ERROR_SUBSCRIPTION_STRIPE_NOT_AVAILABLE: {
    translationKey:
      "common.backendMessages.errors.subscriptionStripeNotAvailable",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_STRIPE_NOT_CONFIGURED: {
    translationKey:
      "common.backendMessages.errors.subscriptionStripeNotConfigured",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_TRIAL_NOT_INITIALIZED: {
    translationKey:
      "common.backendMessages.errors.subscriptionTrialNotInitialized",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_USER_ALREADY_HAS_ACTIVE_SUBSCRIPTION: {
    translationKey:
      "common.backendMessages.errors.subscriptionUserAlreadyHasActiveSubscription",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_NO_STRIPE_SUBSCRIPTION_FOR_BILLING_PORTAL: {
    translationKey:
      "common.backendMessages.errors.subscriptionNoStripeSubscriptionForBillingPortal",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_NOT_FOUND: {
    translationKey: "common.backendMessages.errors.subscriptionNotFound",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_TOKENS_MUST_BE_POSITIVE: {
    translationKey:
      "common.backendMessages.errors.subscriptionTokensMustBePositive",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_WEBHOOK_INVALID_PAYLOAD: {
    translationKey:
      "common.backendMessages.errors.subscriptionWebhookInvalidPayload",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_WEBHOOK_INVALID_SIGNATURE: {
    translationKey:
      "common.backendMessages.errors.subscriptionWebhookInvalidSignature",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_WEBHOOK_MISSING_SIGNATURE: {
    translationKey:
      "common.backendMessages.errors.subscriptionWebhookMissingSignature",
    category: "error",
    hasParams: false,
  },
  ERROR_SUBSCRIPTION_WEBHOOK_SECRET_NOT_CONFIGURED: {
    translationKey:
      "common.backendMessages.errors.subscriptionWebhookSecretNotConfigured",
    category: "error",
    hasParams: false,
  },
  ERROR_TOKEN_ALREADY_USED: {
    translationKey: "common.backendMessages.errors.tokenAlreadyUsed",
    category: "error",
    hasParams: false,
  },
  ERROR_TOKEN_NOT_FOUND: {
    translationKey: "common.backendMessages.errors.tokenNotFound",
    category: "error",
    hasParams: false,
  },
  ERROR_TOO_MANY_LOGIN_ATTEMPTS: {
    translationKey: "common.backendMessages.errors.tooManyLoginAttempts",
    category: "error",
    hasParams: true,
  },
  ERROR_UNEXPECTED_ERROR: {
    translationKey: "common.backendMessages.errors.unexpectedError",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_ACCOUNT_CREATION_FAILED: {
    translationKey: "common.backendMessages.errors.userAccountCreationFailed",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_CANNOT_DELETE_SELF: {
    translationKey: "common.backendMessages.errors.userCannotDeleteSelf",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_DELETION_FAILED: {
    translationKey: "common.backendMessages.errors.userDeletionFailed",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_EMAIL_ALREADY_VERIFIED: {
    translationKey: "common.backendMessages.errors.userEmailAlreadyVerified",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_EMAIL_EXISTS: {
    translationKey: "common.backendMessages.errors.userEmailExists",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_EMAIL_NOT_VERIFIED: {
    translationKey: "common.backendMessages.errors.userEmailNotVerified",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_EMAIL_UPDATE_FAILED: {
    translationKey: "common.backendMessages.errors.userEmailUpdateFailed",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_INACTIVE: {
    translationKey: "common.backendMessages.errors.userInactive",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_INSUFFICIENT_PRIVILEGES: {
    translationKey: "common.backendMessages.errors.userInsufficientPrivileges",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_NOT_ALLOWED: {
    translationKey: "common.backendMessages.errors.userNotAllowed",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_NOT_FOUND: {
    translationKey: "common.backendMessages.errors.userNotFound",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_PRIVACY_NOT_ACCEPTED: {
    translationKey: "common.backendMessages.errors.userPrivacyNotAccepted",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_TERMS_NOT_ACCEPTED: {
    translationKey: "common.backendMessages.errors.userTermsNotAccepted",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_WITH_EMAIL_NOT_FOUND: {
    translationKey: "common.backendMessages.errors.userWithEmailNotFound",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_WITH_ID_NOT_FOUND: {
    translationKey: "common.backendMessages.errors.userWithIdNotFound",
    category: "error",
    hasParams: false,
  },
  ERROR_USER_WITH_USERNAME_NOT_FOUND: {
    translationKey: "common.backendMessages.errors.userWithUsernameNotFound",
    category: "error",
    hasParams: false,
  },
  SUCCESS_ACCOUNT_SCHEDULED_FOR_DELETION: {
    translationKey:
      "common.backendMessages.success.accountScheduledForDeletion",
    category: "success",
    hasParams: false,
  },
  SUCCESS_FILE_DELETED: {
    translationKey: "common.backendMessages.success.fileDeleted",
    category: "success",
    hasParams: false,
  },
  SUCCESS_FILE_UPLOADED: {
    translationKey: "common.backendMessages.success.fileUploaded",
    category: "success",
    hasParams: false,
  },
  SUCCESS_FILE_UPLOADED_TO_SESSION: {
    translationKey: "common.backendMessages.success.fileUploadedToSession",
    category: "success",
    hasParams: false,
  },
  SUCCESS_FILE_UPLOAD_URL_GENERATED: {
    translationKey: "common.backendMessages.success.fileUploadUrlGenerated",
    category: "success",
    hasParams: false,
  },
  SUCCESS_LOGGED_OUT: {
    translationKey: "common.backendMessages.success.loggedOut",
    category: "success",
    hasParams: false,
  },
  SUCCESS_PASSWORD_RECOVERY_EMAIL_SENT: {
    translationKey: "common.backendMessages.success.passwordRecoveryEmailSent",
    category: "success",
    hasParams: false,
  },
  SUCCESS_PASSWORD_UPDATED: {
    translationKey: "common.backendMessages.success.passwordUpdated",
    category: "success",
    hasParams: false,
  },
  SUCCESS_SESSION_CLOSED: {
    translationKey: "common.backendMessages.success.sessionClosed",
    category: "success",
    hasParams: true,
  },
  SUCCESS_USER_DELETED: {
    translationKey: "common.backendMessages.success.userDeleted",
    category: "success",
    hasParams: false,
  },
  SUCCESS_USER_VERIFIED: {
    translationKey: "common.backendMessages.success.userVerified",
    category: "success",
    hasParams: false,
  },
  SUCCESS_VERIFICATION_EMAIL_SENT: {
    translationKey: "common.backendMessages.success.verificationEmailSent",
    category: "success",
    hasParams: false,
  },
} as const satisfies Record<string, BackendMessageDefinition>;

export type BackendMessageKey = keyof typeof BACKEND_MESSAGE_MAP;
